import { render, staticRenderFns } from "./BulkBudgetCreationHelp.vue?vue&type=template&id=010bb1fc&scoped=true"
import script from "./BulkBudgetCreationHelp.vue?vue&type=script&lang=js"
export * from "./BulkBudgetCreationHelp.vue?vue&type=script&lang=js"
import style0 from "./BulkBudgetCreationHelp.vue?vue&type=style&index=0&id=010bb1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010bb1fc",
  null
  
)

export default component.exports